module.exports = __webpack_public_path__ + "img/video.60a48ae3.jpg";